import React from "react";
import Modal from "../../ui/Modal";
import Form from "../../ui/Form";
import {
  useCreateCarInfoTypeMutation,
  useUpdateCarInfoTypeMutation
} from "../../utils/carInfoType.utils";
import { makeSlug } from "../../utils/string.utils";

export default function CarInfoTypeAddEdit({ modal, toggle, editItem }) {
  const id = editItem?.id ?? "";

  const { loading, createCarInfoType } = useCreateCarInfoTypeMutation(["createCarInfoType"]);

  const { loading: updating, updateCarInfoType } = useUpdateCarInfoTypeMutation([
    "updateCarInfoType"
  ]);

  const fields = [
    {
      label: "Name",
      name: "name",
      type: "text",
      placeholder: "Enter a car info type name",
      col: { md: 12 },
      rules: { required: "This is required field!" }
    }
  ];

  const defaultValues = {
    name: editItem?.name ?? ""
  };

  const onSubmit = async (data) => {
    const name = data?.name ?? "";
    const slug = makeSlug(name);

    const values = {
      name,
      slug
    };

    if (!!id) {
      const afterUpdated = await updateCarInfoType({ id, ...values });

      if (afterUpdated?.status === 200) {
        toggle();
      }
      return;
    }

    const afterCreated = await createCarInfoType({ ...values });
    if (afterCreated?.status === 201) {
      toggle();
    }
  };

  const isLoading = loading || updating;

  const title = `${!!id ? "Update" : "Create"} Car info type`;

  return (
    <Modal modal={modal} toggle={toggle} title={title}>
      <Form
        fields={fields}
        onSubmit={onSubmit}
        defaultValues={defaultValues}
        submitbtnText={isLoading ? `${!!id ? "Updating..." : "Creating...."}` : title}
        toggle={toggle}
        loading={typeof isLoading === "boolean" ? isLoading : undefined}
      />
    </Modal>
  );
}
